import Api from '@/services/Api'

const HEADERURL = 'wms/recepcion/';
const ACTION_ADD_DETAIL = 'agregar_detalle';
const ACTION_DELETE_DETAIL = 'eliminar_detalle';
const ACTION_GENERAR_COTIZACION = 'generar_cotizacion';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_REPORTE_PDF = 'pdf';

export default {

    fetch(params) {
        return Api().get(HEADERURL, {
            params: params
        });
    },

    getById(codigo) {
        return Api().get(`${HEADERURL}${codigo}`);
    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);
    },

    addDetail(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ADD_DETAIL}/`, params);
    },

    deleteDetail(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_DELETE_DETAIL}/`, params);
    },

    asignarEncargado(id, params) {
        return Api().post(`${HEADERURL}${id}/asignar_encargado/`, params);
    },

    abrir(id) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);
    },

    cerrar(id) {
        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);
    },

    anular(id) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);
        self.orden_compra_info = self.orden_compra_
    },

    pdf(id) {
        return Api().get(`${HEADERURL}${id}/${ACTION_REPORTE_PDF}/`);
    },

    generar_cotizacion(id) {
        return Api().post(`${HEADERURL}${id}/${ACTION_GENERAR_COTIZACION}/`);
    },

    obtenerDetalleOrdenCompra(id) {
        return Api().get(`${HEADERURL}${id}/obtener_detalle_orden_compra/`);
    },

    obtenerDetallesOrdenCompraPorProducto(id, params) {
        let queryParams = "";
        if (params) {
            queryParams = Object.keys(params).map(key => {
                const value = params[key];
                if (Array.isArray(value)) {
                    return value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&');
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }).join('&');
        }
        const url = `${HEADERURL}${id}/obtener_detalles_orden_compra_por_producto/${queryParams ? '?' + queryParams : ''}`;
        return Api().get(url);
    },

    asignarTransporteTercerizado(id, params) {
        return Api().post(`${HEADERURL}${id}/asignar_transporte_tercerizado/`, params);
    },

    obtenerChoicesEmpresa() {
        return Api().get('wms/transporte-tercerizado/choices_empresa/');
    }

}